/**
 * Layouty per typ dokumentu (Etap 3, T3.5) — mapowanie klasa dokumentu → slug
 * kartoteki systemowej (`system_modules.slug` w schemacie tenanta).
 *
 * Mirror 1:1 backendowej mapy `apps/api/lib/documents/class-kartoteka-slug.ts`
 * (źródło prawdy — zbieżność nazw klasa↔slug to konwencja seedów,
 * `apps/api/lib/seed-system-modules.ts`). Panel ITE potrzebuje TEJ mapy lokalnie,
 * bo `GET /api/admin/kartoteki/system/[slug]/views` (biblioteka widoków ADM) adresuje
 * kartotekę SLUGIEM, nie klasą dokumentu — w przeciwieństwie do tenantowego
 * `GET /api/document-types/form-layouts?class=`, gdzie mapowanie robi backend.
 *
 * Odpowiednik zbioru (nie mapy) używany gdzie indziej w admin SPA:
 * `apps/admin/src/pages/system-modules/document-module-slugs.ts`.
 */

import type { DocumentClass } from '@saas/shared';

export const CLASS_KARTOTEKA_SLUGS: Record<DocumentClass, string> = {
  purchase_invoice: 'purchase_invoices',
  sale_invoice: 'sale_invoices',
  contract: 'contracts',
  letter: 'letters',
  commercial: 'commercial',
  internal: 'internal',
  specjalne: 'specjalne',
};

/** Zwraca slug kartoteki systemowej dla klasy dokumentu. */
export function getKartotekaSlugForClass(cls: DocumentClass): string {
  return CLASS_KARTOTEKA_SLUGS[cls];
}

/** Odwrotny lookup: slug kartoteki systemowej → klasa dokumentu, albo `null` gdy to nie kartoteka dokumentu. */
const KARTOTEKA_SLUG_TO_CLASS: Record<string, DocumentClass> = Object.fromEntries(
  (Object.entries(CLASS_KARTOTEKA_SLUGS) as [DocumentClass, string][]).map(([cls, slug]) => [
    slug,
    cls,
  ]),
);

/** Zwraca klasę dokumentu dla slugu kartoteki systemowej, albo `null` (slug spoza dokumentów). */
export function getClassForKartotekaSlug(slug: string): DocumentClass | null {
  return KARTOTEKA_SLUG_TO_CLASS[slug] ?? null;
}
